import { Theme } from '@mui/material/styles';

export default function Divider({ palette }: Theme) {
  return {
    MuiDivider: {
      styleOverrides: {
        root: {
          color: palette.common.white,
          '&::before, &::after': {
            borderColor: palette.common.white,
          },
          marginTop: 2,
          marginBottom: 2,
        },
      },
    },
  };
}
